import { createSvgIcon } from '@mui/material';

const VideoCameraIcon = (props) => {
  const IconCmp = createSvgIcon(
    <>
      <path
        d="M20.1673 5.18725C20.1673 4.63192 20.1673 4.35426 20.0575 4.22568C19.9622 4.11412 19.8193 4.05491 19.673 4.06642C19.5045 4.07969 19.3081 4.27603 18.9154 4.66871L15.584 8.00016L18.9154 11.3316C19.3081 11.7243 19.5045 11.9206 19.673 11.9339C19.8193 11.9454 19.9622 11.8862 20.0575 11.7746C20.1673 11.6461 20.1673 11.3684 20.1673 10.8131V5.18725Z"
        stroke="currentColor"
        stroke-width="1.7"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.83398 5.9835C1.83398 4.44335 1.83398 3.67328 2.13372 3.08502C2.39737 2.56758 2.81806 2.14688 3.33551 1.88323C3.92377 1.5835 4.69384 1.5835 6.23398 1.5835H11.184C12.7241 1.5835 13.4942 1.5835 14.0825 1.88323C14.5999 2.14688 15.0206 2.56758 15.2843 3.08502C15.584 3.67328 15.584 4.44335 15.584 5.9835V10.0168C15.584 11.557 15.584 12.327 15.2843 12.9153C15.0206 13.4327 14.5999 13.8534 14.0825 14.1171C13.4942 14.4168 12.7241 14.4168 11.184 14.4168H6.23398C4.69384 14.4168 3.92377 14.4168 3.33551 14.1171C2.81806 13.8534 2.39737 13.4327 2.13372 12.9153C1.83398 12.327 1.83398 11.557 1.83398 10.0168V5.9835Z"
        stroke="currentColor"
        stroke-width="1.7"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </>,
    'VideoCameraIcon',
  );
  return <IconCmp style={{ fill: 'none' }} viewBox={'0 0 22 16'} {...props} />;
};
export default VideoCameraIcon;
